import { Navigate, useSearchParams } from "react-router-dom";

export const SharedLocationRedirect = () => {
  const [searchParams] = useSearchParams();

  return (
    <Navigate
      to={`/?loc=1&lat=${searchParams.get("lat")}&lng=${searchParams.get("lng")}`}
    />
  );
};
